import React from 'react';
import { toast } from 'react-toastify';
import ToastComp from 'src/components/ToastComp';

// Fit-to-content on every screen (was sm+ only, so phones got a full-width bar); capped to the
// viewport with a 16px gutter so long messages still wrap on small screens.
const TOAST_CLASS = `min-w-[180px] w-fit max-w-[calc(100vw-32px)] !shadow-lg !py-2 !px-4 !border-none border-utilityBlack900 !bg-[#0C111D] !mb-0`;

const success = (title: string, subTitle: string = '', className: string = '', isShowDismissBtn?: boolean, isShowPrimaryBtn?: boolean, primaryBtnText?: string, onPrimaryBtnClick?: () => void) => {
    const toastId = `success-${title}`;

    toast.success(
        <ToastComp
            title={title}
            desc={subTitle}
            type="success"
            isShowPrimaryBtn={isShowPrimaryBtn}
            isShowDismissBtn={isShowDismissBtn}
            primaryBtnText={primaryBtnText}
            onPrimaryBtnClick={onPrimaryBtnClick}
        />,
        {
            toastId,
            className: `${className} ${TOAST_CLASS}`,
            icon: false,
            hideProgressBar: true,
            theme: 'dark',
        }
    );
};

const copy = (title: string, subTitle: string = '', className: string = '', position: (typeof toast.POSITION)[keyof typeof toast.POSITION] = toast.POSITION.BOTTOM_CENTER) => {
    toast.dismiss('copy-msg');

    toast.success(<ToastComp title={title} desc={subTitle} type="success" isIcon={false} />, {
        toastId: 'copy-msg',
        className: `${className} ${TOAST_CLASS}`,
        icon: false,
        hideProgressBar: true,
        position: position,
    });
};

const error = (title: string, subTitle: string = '', className: string = '', isShowDismissBtn?: boolean, isShowPrimaryBtn?: boolean, primaryBtnText?: string, onPrimaryBtnClick?: () => void) => {
    // Use the message as toastId so the same error won't stack if already visible on screen.
    const toastId = `error-${title}`;

    toast.error(
        <ToastComp
            title={title}
            desc={subTitle}
            type="error"
            isShowDismissBtn={isShowDismissBtn}
            isShowPrimaryBtn={isShowPrimaryBtn}
            primaryBtnText={primaryBtnText}
            onPrimaryBtnClick={onPrimaryBtnClick}
        />,
        {
            toastId,
            className: `${className} ${TOAST_CLASS}`,
            icon: false,
            hideProgressBar: true,
            theme: 'dark',
        }
    );
};

const info = (title: string, subTitle: string = '', className: string = '', isShowDismissBtn?: boolean, isShowPrimaryBtn?: boolean, primaryBtnText?: string, onPrimaryBtnClick?: () => void) => {
    toast.info(
        <ToastComp
            title={title}
            desc={subTitle}
            type="info"
            isShowPrimaryBtn={isShowPrimaryBtn}
            isShowDismissBtn={isShowDismissBtn}
            primaryBtnText={primaryBtnText}
            onPrimaryBtnClick={onPrimaryBtnClick}
        />,
        {
            className: `${className} ${TOAST_CLASS}`,
            icon: false,
            hideProgressBar: true,
            autoClose: false,
            theme: 'dark',
        }
    );
};

const WalToast = { success, error, info, copy };

export default WalToast;
